/**
 * 商品オプション管理とカート追加処理
 * 名入れ・フォント・誕生石などのオプションに応じて手数料商品をカートに追加
 */

class ProductOptionsBundle {
  constructor(sectionId, settings) {
    this.sectionId = sectionId;
    this.settings = settings || {};
    this.bundleKey = null;
    this.init();
  }

  init() {
    if (this.settings.showEngraving) this.initEngravingOption();
    if (this.settings.showBirthstone) this.initBirthstoneOption();
    if (this.settings.showNormalClaw) this.initNormalClawOption();
    if (this.settings.showSlideAdjuster) this.initSlideAdjusterOption();
    if (this.settings.showIdentificationCard) this.initIdentificationCardOption();
    if (this.settings.showCertificate) this.initCertificateOption();

    this.setupValidation();
    this.initPriceUpdate();
  }

  initSimpleOption(name, sectionId) {
    const radios = document.querySelectorAll(`input[name="${name}-${sectionId}"]`);
    if (!radios.length) return;
    radios.forEach((radio) => {
      radio.addEventListener('change', () => this.updatePrice());
    });
  }

  initNormalClawOption() {
    this.initSimpleOption('normal-claw', this.sectionId);
  }

  initSlideAdjusterOption() {
    this.initSimpleOption('slide-adjuster', this.sectionId);
  }

  initIdentificationCardOption() {
    this.initSimpleOption('identification-card', this.sectionId);
  }

  initCertificateOption() {
    this.initSimpleOption('certificate', this.sectionId);
  }

  /**
   * 名入れオプションの初期化
   */
  initEngravingOption() {
    const engravingRadios = document.querySelectorAll(
      `input[name="engraving-${this.sectionId}"]`
    );
    const engravingFields = document.getElementById(`engraving-fields-${this.sectionId}`);
    const fontSelect = document.getElementById(`engraving-font-${this.sectionId}`);
    const textInput = document.getElementById(`engraving-text-${this.sectionId}`);

    if (!engravingRadios.length || !engravingFields) return;

    engravingRadios.forEach((radio) => {
      radio.addEventListener('change', () => {
        const isEngraving = radio.value === 'yes';
        engravingFields.style.display = isEngraving ? 'flex' : 'none';
        
        if (fontSelect) {
          fontSelect.disabled = !isEngraving;
          if (!isEngraving) fontSelect.value = '';
        }
        
        if (textInput) {
          textInput.disabled = !isEngraving;
          if (!isEngraving) textInput.value = '';
        }
        
        // 価格を更新
        this.updatePrice();
      });
    });
  }

  /**
   * 誕生石オプションの初期化
   */
  initBirthstoneOption() {
    const birthstoneRadios = document.querySelectorAll(
      `input[name="birthstone-${this.sectionId}"]`
    );
    const birthstoneFields = document.getElementById(`birthstone-fields-${this.sectionId}`);
    const birthstoneSelect = document.getElementById(`birthstone-select-${this.sectionId}`);

    if (!birthstoneRadios.length || !birthstoneFields) return;

    birthstoneRadios.forEach((radio) => {
      radio.addEventListener('change', () => {
        const hasBirthstone = radio.value === 'yes';
        birthstoneFields.style.display = hasBirthstone ? 'flex' : 'none';
        
        if (birthstoneSelect) {
          birthstoneSelect.disabled = !hasBirthstone;
          if (!hasBirthstone) birthstoneSelect.value = '';
        }
        
        // 価格を更新
        this.updatePrice();
      });
    });
  }

  /**
   * バリデーション設定
   */
  setupValidation() {
    const productForm = document.querySelector(`#product-form-${this.sectionId}`);
    if (!productForm) return;

    // フォーム送信前にバリデーション
    productForm.addEventListener('submit', (e) => {
      if (!this.validateOptions()) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    });
  }

  /**
   * オプションのバリデーション
   */
  validateOptions() {
    let isValid = true;

    // 名入れオプションのバリデーション
    const engravingYes = document.querySelector(
      `input[name="engraving-${this.sectionId}"][value="yes"]`
    );
    if (engravingYes && engravingYes.checked) {
      // フォント選択のバリデーション
      const fontSelect = document.getElementById(`engraving-font-${this.sectionId}`);
      const fontSelectError = document.getElementById(`engraving-font-error-${this.sectionId}`);
      
      if (!fontSelect || !fontSelect.value) {
        isValid = false;
        if (fontSelectError) {
          fontSelectError.textContent = 'フォントを選択してください';
          fontSelectError.style.display = 'block';
        }
        if (fontSelect) {
          fontSelect.classList.add('error');
        }
      } else {
        if (fontSelectError) {
          fontSelectError.style.display = 'none';
        }
        if (fontSelect) {
          fontSelect.classList.remove('error');
        }
      }
      
      // 刻印文字のバリデーション
      const engravingText = document.getElementById(`engraving-text-${this.sectionId}`);
      const engravingTextError = document.getElementById(`engraving-text-error-${this.sectionId}`);
      
      if (!engravingText || !engravingText.value.trim()) {
        isValid = false;
        if (engravingTextError) {
          engravingTextError.textContent = '刻印する文字を入力してください';
          engravingTextError.style.display = 'block';
        }
        if (engravingText) {
          engravingText.classList.add('error');
        }
      } else if (engravingText.value.trim().length > (this.settings.engravingMaxLength || 9)) {
        isValid = false;
        if (engravingTextError) {
          engravingTextError.textContent = `刻印は${this.settings.engravingMaxLength || 9}文字までです`;
          engravingTextError.style.display = 'block';
        }
        if (engravingText) {
          engravingText.classList.add('error');
        }
      } else {
        if (engravingTextError) {
          engravingTextError.style.display = 'none';
        }
        if (engravingText) {
          engravingText.classList.remove('error');
        }
      }
    }

    // 誕生石オプションのバリデーション
    const birthstoneYes = document.querySelector(
      `input[name="birthstone-${this.sectionId}"][value="yes"]`
    );
    if (birthstoneYes && birthstoneYes.checked) {
      const birthstoneSelect = document.getElementById(`birthstone-select-${this.sectionId}`);
      const birthstoneSelectError = document.getElementById(`birthstone-select-error-${this.sectionId}`);
      
      if (!birthstoneSelect || !birthstoneSelect.value) {
        isValid = false;
        if (birthstoneSelectError) {
          birthstoneSelectError.textContent = '誕生石を選択してください';
          birthstoneSelectError.style.display = 'block';
        }
        if (birthstoneSelect) {
          birthstoneSelect.classList.add('error');
        }
      } else {
        if (birthstoneSelectError) {
          birthstoneSelectError.style.display = 'none';
        }
        if (birthstoneSelect) {
          birthstoneSelect.classList.remove('error');
        }
      }
    }

    return isValid;
  }

  /**
   * オプション情報を取得
   */
  getOptions() {
    const options = {
      engraving: 'none',
      birthstone: 'none',
      normalClaw: 'none',
      slideAdjuster: 'none',
      identificationCard: 'none',
      certificate: 'none'
    };

    const getRadioValue = (name) => {
      const radio = document.querySelector(`input[name="${name}-${this.sectionId}"]:checked`);
      return radio ? radio.value : 'none';
    };

    if (this.settings.showEngraving) {
      options.engraving = getRadioValue('engraving');
      if (options.engraving === 'yes') {
        const fontSelect = document.getElementById(`engraving-font-${this.sectionId}`);
        const textInput = document.getElementById(`engraving-text-${this.sectionId}`);
        if (fontSelect) options.engravingFont = fontSelect.value;
        if (textInput) options.engravingText = textInput.value.trim();
      }
    }
    if (this.settings.showBirthstone) {
      options.birthstone = getRadioValue('birthstone');
      if (options.birthstone === 'yes') {
        const birthstoneSelect = document.getElementById(`birthstone-select-${this.sectionId}`);
        if (birthstoneSelect) options.birthstoneSelect = birthstoneSelect.value;
      }
    }
    if (this.settings.showNormalClaw) options.normalClaw = getRadioValue('normal-claw');
    if (this.settings.showSlideAdjuster) options.slideAdjuster = getRadioValue('slide-adjuster');
    if (this.settings.showIdentificationCard) options.identificationCard = getRadioValue('identification-card');
    if (this.settings.showCertificate) options.certificate = getRadioValue('certificate');

    return options;
  }

  /**
   * Line item propertiesを生成
   */
  getLineItemProperties(options) {
    const properties = {};

    // 選択されたオプションのみプロパティに追加（なしの場合は表示しない）
    if (options.engraving === 'yes') {
      properties['名入れ有無'] = 'あり';
      if (options.engravingFont) {
        properties['フォント'] = options.engravingFont;
      }
      if (options.engravingText) {
        properties['名入れ文字'] = options.engravingText;
      }
    }

    if (options.birthstone === 'yes') {
      properties['シークレットストーン有無'] = 'あり';
      if (options.birthstoneSelect) {
        properties['誕生石'] = options.birthstoneSelect;
      }
    }
    if (options.normalClaw === 'yes') {
      properties['通常爪への変更'] = 'あり';
    }
    if (options.slideAdjuster === 'yes') {
      properties['スライド式アジャスターへ変更'] = 'あり';
    }
    if (options.identificationCard === 'yes') {
      properties['識別カード発行'] = 'あり';
    }
    if (options.certificate === 'yes') {
      properties['鑑別書発行'] = 'あり';
    }

    // バンドルキーを生成（初回のみ）
    if (!this.bundleKey) {
      this.bundleKey = `BUNDLE_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    }
    properties['_bundle_key'] = this.bundleKey;

    return properties;
  }

  /**
   * 手数料商品のvariant_idを取得（カート追加用）
   * 商品IDからvariant IDを取得する必要があるが、価格計算には商品価格を使用
   */
  getFeeVariantIds(options) {
    const variantIds = [];

    // 名入れ手数料
    if (options.engraving === 'yes') {
      const engravingVariantId = this.settings.engravingVariantId;
      if (engravingVariantId) {
        variantIds.push(engravingVariantId);
      }
    }

    if (options.birthstone === 'yes' && this.settings.birthstoneVariantId) {
      variantIds.push(this.settings.birthstoneVariantId);
    }
    if (options.normalClaw === 'yes' && this.settings.normalClawVariantId) {
      variantIds.push(this.settings.normalClawVariantId);
    }
    if (options.slideAdjuster === 'yes' && this.settings.slideAdjusterVariantId) {
      variantIds.push(this.settings.slideAdjusterVariantId);
    }
    if (options.identificationCard === 'yes' && this.settings.identificationCardVariantId) {
      variantIds.push(this.settings.identificationCardVariantId);
    }
    if (options.certificate === 'yes' && this.settings.certificateVariantId) {
      variantIds.push(this.settings.certificateVariantId);
    }

    return variantIds;
  }

  /**
   * カート追加用のitems配列を生成
   */
  getCartItems(mainVariantId, quantity, options) {
    const items = [];

    // メイン商品
    const mainItem = {
      id: mainVariantId,
      quantity: quantity,
      properties: this.getLineItemProperties(options)
    };
    items.push(mainItem);

    // 手数料商品
    const feeVariantIds = this.getFeeVariantIds(options);
    feeVariantIds.forEach((variantId) => {
      items.push({
        id: variantId,
        quantity: 1,
        properties: {
          '_bundle_key': this.bundleKey
        }
      });
    });

    return items;
  }

  /**
   * 価格更新の初期化
   */
  initPriceUpdate() {
    this.feePrices = {
      engraving: this.settings.engravingPrice || 0,
      birthstone: this.settings.birthstonePrice || 0,
      normalClaw: this.settings.normalClawPrice || 0,
      slideAdjuster: this.settings.slideAdjusterPrice || 0,
      identificationCard: this.settings.identificationCardPrice || 0,
      certificate: this.settings.certificatePrice || 0
    };
    this.basePrice = null;
    
    // メイン商品の価格を取得（少し遅延して読み取る）
    setTimeout(() => {
      this.getBasePrice();
    }, 500);
    
    // 定期的に価格をチェックして更新（product-info.jsの更新後に再計算）
    this.priceCheckInterval = setInterval(() => {
      if (this.basePrice === null) {
        this.getBasePrice();
      } else {
        this.updatePrice();
      }
    }, 1000);
  }

  /**
   * メイン商品の価格を取得
   */
  getBasePrice() {
    // 価格要素から現在の価格を読み取る
    const priceElement = document.getElementById(`price-${this.sectionId}`);
    if (!priceElement) return;
    
    const priceItem = priceElement.querySelector('.price-item--last') || 
                      priceElement.querySelector('.price-item--sale') ||
                      priceElement.querySelector('.price-item');
    
    if (priceItem) {
      // 価格テキストから数値を抽出（¥記号とカンマを除去）
      const priceText = priceItem.textContent.replace(/[¥,]/g, '').trim();
      const priceValue = parseInt(priceText, 10);
      
      if (!isNaN(priceValue)) {
        // セント単位に変換
        this.basePrice = priceValue * 100;
        this.updatePrice();
      }
    }
    
    // バリアント変更時にも価格を更新（少し遅延して読み取る）
    const variantSelects = document.querySelector(`variant-selects[data-section="${this.sectionId}"]`);
    if (variantSelects) {
      variantSelects.addEventListener('change', () => {
        setTimeout(() => {
          this.getBasePrice();
        }, 300);
      });
    }
  }

  /**
   * 価格を更新
   */
  updatePrice() {
    if (this.basePrice === null) {
      // basePriceがnullの場合は再取得を試みる
      this.getBasePrice();
      return;
    }
    
    let totalPrice = this.basePrice;
    
    // 名入れ手数料を加算
    const engravingYes = document.querySelector(
      `input[name="engraving-${this.sectionId}"][value="yes"]`
    );
    if (engravingYes && engravingYes.checked && this.feePrices.engraving) {
      totalPrice += this.feePrices.engraving;
    }
    
    const birthstoneYes = document.querySelector(`input[name="birthstone-${this.sectionId}"][value="yes"]`);
    if (birthstoneYes && birthstoneYes.checked && this.feePrices.birthstone) {
      totalPrice += this.feePrices.birthstone;
    }
    const normalClawYes = document.querySelector(`input[name="normal-claw-${this.sectionId}"][value="yes"]`);
    if (normalClawYes && normalClawYes.checked && this.feePrices.normalClaw) {
      totalPrice += this.feePrices.normalClaw;
    }
    const slideAdjusterYes = document.querySelector(`input[name="slide-adjuster-${this.sectionId}"][value="yes"]`);
    if (slideAdjusterYes && slideAdjusterYes.checked && this.feePrices.slideAdjuster) {
      totalPrice += this.feePrices.slideAdjuster;
    }
    const identificationCardYes = document.querySelector(`input[name="identification-card-${this.sectionId}"][value="yes"]`);
    if (identificationCardYes && identificationCardYes.checked && this.feePrices.identificationCard) {
      totalPrice += this.feePrices.identificationCard;
    }
    const certificateYes = document.querySelector(`input[name="certificate-${this.sectionId}"][value="yes"]`);
    if (certificateYes && certificateYes.checked && this.feePrices.certificate) {
      totalPrice += this.feePrices.certificate;
    }

    this.renderPrice(totalPrice);
  }

  /**
   * 価格を表示
   */
  renderPrice(price) {
    const priceElement = document.getElementById(`price-${this.sectionId}`);
    if (!priceElement) {
      console.warn('価格要素が見つかりません:', `price-${this.sectionId}`);
      return;
    }
    
    // 価格をフォーマット
    const formattedPrice = this.formatPrice(price);
    
    // すべての価格表示要素を更新
    const priceItems = priceElement.querySelectorAll('.price-item');
    let updated = false;
    
    if (priceItems.length > 0) {
      priceItems.forEach((item) => {
        // visually-hiddenクラスが付いている要素はスキップ
        if (!item.closest('.visually-hidden')) {
          item.textContent = formattedPrice;
          updated = true;
        }
      });
      
      if (!updated) {
        console.warn('更新可能な価格要素が見つかりませんでした');
      }
    } else {
      // フォールバック: 直接テキストを更新
      const priceContainer = priceElement.querySelector('.price__container');
      if (priceContainer) {
        const priceRegular = priceContainer.querySelector('.price__regular');
        const priceSale = priceContainer.querySelector('.price__sale');
        
        if (priceRegular) {
          const regularItem = priceRegular.querySelector('.price-item');
          if (regularItem) {
            regularItem.textContent = formattedPrice;
            updated = true;
          }
        }
        
        if (priceSale) {
          const saleItem = priceSale.querySelector('.price-item--last');
          if (saleItem) {
            saleItem.textContent = formattedPrice;
            updated = true;
          }
        }
        
        if (!updated) {
          console.warn('価格要素が見つかりません。構造を確認してください。');
        }
      } else {
        console.warn('price__container要素が見つかりません');
      }
    }
  }

  /**
   * 価格をフォーマット
   */
  formatPrice(price) {
    // Shopifyの価格はセント単位（100倍）なので、100で割る
    const priceInYen = price / 100;
    
    // Shopifyのmoneyフィルターと同じ形式でフォーマット（¥記号付き）
    return '¥' + new Intl.NumberFormat('ja-JP', {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(priceInYen);
  }

  /**
   * クリーンアップ
   */
  destroy() {
    if (this.priceCheckInterval) {
      clearInterval(this.priceCheckInterval);
    }
  }
}

// グローバルに公開
window.ProductOptionsBundle = ProductOptionsBundle;
